interface Props {
  gradient: [string, string]
  title: string
  className?: string
}

// Client-rendered placeholder art (Document 11 §6) — no image asset
// required. Swap for real thumbnails once CyberTales animation is ready.
export function EpisodeThumbnail({ gradient, title, className = '' }: Props) {
  return (
    <div
      className={`relative flex items-center justify-center overflow-hidden ${className}`}
      style={{ background: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})` }}
    >
      <div className="absolute inset-0 bg-cyber-grid bg-[length:18px_18px] opacity-40" />
      <svg
        className="relative h-10 w-10 text-white/80 drop-shadow"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 5v14l11-7z" />
      </svg>
      <span className="sr-only">{title}</span>
    </div>
  )
}
